import { Input, message, Modal } from 'antd';
import React, { useState, RefObject } from 'react';

interface EditorRef {
  getSelectedText?: () => string;
  insertLink: (params: { href: string; text?: string }) => void;
}

interface AddLinkFormProps {
  editorRef: RefObject<EditorRef>;
  setVisible: (visible: boolean) => void;
  visible: boolean;
  setLinkText: (text: string) => void;
  linkText: string;
}

const AddLinkForm: React.FC<AddLinkFormProps> = ({
  editorRef,
  setVisible,
  visible,
  setLinkText,
  linkText,
}) => {
  const [linkUrl, setLinkUrl] = useState('');
  const insertLink = () => {
    if (!linkUrl) {
      message.warning('Please enter URL');
      return;
    }

    let formattedLink = linkUrl.trim();

    if (!/^https?:\/\//i.test(formattedLink)) {
      formattedLink = 'https://' + formattedLink;
    }

    // If user selected text in the editor, just apply href
    if (
      editorRef.current?.getSelectedText &&
      editorRef.current.getSelectedText()
    ) {
      editorRef.current?.insertLink({
        href: formattedLink,
      });
    } else {
      // No text selected linkText or fallback to linkUrl
      editorRef.current?.insertLink({
        text: linkText || linkUrl,
        href: formattedLink,
      });
    }

    setVisible(false);
    setLinkUrl('');
    setLinkText('');
  };
  return (
    <>
      <Modal
        title='Add Link'
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
      >
        <Input
          placeholder='Text'
          value={linkText}
          onChange={(e) => setLinkText(e.target.value)}
          className='mb-2'
        />
        <Input
          placeholder='Enter link'
          value={linkUrl}
          onChange={(e) => setLinkUrl(e.target.value)}
          onPressEnter={insertLink}
        />
        <div style={{ marginTop: 16, textAlign: 'right' }}>
          <button
            className='zl-btn secondary'
            type='submit'
            onClick={insertLink}
          >
            Save
          </button>
        </div>
      </Modal>
    </>
  );
};

export default AddLinkForm;
